import { Colorizers } from '@leverege/ui-attributes';
const getColor = (color, item, cxt) => {
  if (typeof color === 'string') {
    return color;
  }
  if (color && typeof color === 'object') {
    return Colorizers.getColor(color, item, cxt);
  }
  return null;
};
const getNumber = (num, item, cxt, dVal = null) => {
  if (typeof num === 'number') {
    return num;
  }
  if (num && typeof num === 'object') {
    return dVal; // Numberizer.getNumber( num, item, cxt )
  }
  return dVal;
};
const getPattern = (pattern, item, cxt, dVal = null) => {
  if (typeof pattern === 'string') {
    const t = pattern.trim();
    if (t.length === 0) {
      return null;
    }
    return t;
  }
  if (pattern && typeof pattern === 'object') {
    return dVal; // Value.get( num, item, cxt )
  }
  return dVal;
};
const getDashArray = (array, item, cxt, dVal = null) => {
  if (Array.isArray(array)) {
    return array;
  }
  if (array && typeof array === 'object') {
    return dVal; // Value.get( num, item, cxt )
  }
  return dVal;
};
function getVisible(show, hide, zoom) {
  let visible = true;
  if (typeof show === 'number') {
    if (typeof hide === 'number') {
      if (hide > show) {
        visible = zoom >= show && zoom <= hide;
      }
    } else {
      visible = zoom >= show;
    }
  } else if (typeof hide === 'number') {
    visible = zoom <= hide;
  }
  return visible;
}
const HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/;
const RGB_REGEX = /^rgba?\([\s]*(\d+)[\s]*,[\s]*(\d+)[\s]*,[\s]*(\d+),?([^,\s)]+)?/;
function colorStringToArray(hex) {
  let c;
  if (Array.isArray(hex)) {
    return hex;
  }
  if (hex != null) {
    if (HEX_REGEX.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = `0x${c.join('')}`;
      return [c >> 16 & 255, c >> 8 & 255, c & 255];
    }
    if (RGB_REGEX.test(hex)) {
      const [, r, g, b] = RGB_REGEX.exec(hex);
      return [parseInt(r), parseInt(g), parseInt(b)];
    }
  }
  return [255, 255, 255, 0];
}
function getColorAndOpacity(color, opacity) {
  const c = colorStringToArray(color);
  return [...c, opacity * 255];
}
function latLng2Point(latLng, map) {
  if (!map || !map.getProjection()) {
    return null;
  }
  const topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  const bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  const scale = 2 ** map.getZoom();
  const worldPoint = map.getProjection().fromLatLngToPoint(latLng);
  return new window.google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}
export default {
  getColor,
  getNumber,
  getPattern,
  getDashArray,
  colorStringToArray,
  getColorAndOpacity,
  getVisible,
  latLng2Point
};